function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.2929 4.29289C17.6834 3.90237 18.3166 3.90237 18.7071 4.29289C19.0676 4.65338 19.0953 5.22061 18.7903 5.6129L18.7071 5.70711L8.70711 15.7071C8.34662 16.0676 7.77939 16.0953 7.3871 15.7903L7.29289 15.7071L1.29289 9.70711C0.902369 9.31658 0.902369 8.68342 1.29289 8.29289C1.65338 7.93241 2.22061 7.90468 2.6129 8.2097L2.70711 8.29289L8 13.585L17.2929 4.29289Z",
  fill: "#FE5B6A"
});

var SvgICheck2020 = function SvgICheck2020(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgICheck2020, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/i-check-20-20.584fc3b0.svg";
export { ForwardRef as ReactComponent };